import styled from "@emotion/styled";

export const Home = styled.div``;
